import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Scrollbar from 'smooth-scrollbar'
import {
  ScrollbarOptions,
  ScrollListener,
  ScrollStatus,
} from 'smooth-scrollbar/interfaces'
import {
  Ref,
  ref,
  onMounted,
  onUnmounted,
  onUpdated,
  onBeforeUnmount as onBeforeUnmountVue,
} from 'vue'

type Props = {
  hiddenTracks?: boolean
  updateOn?: number
  yPosition?: number
  onBeforeUnmount?: (scrollInstance: Scrollbar) => void
}

type Emits = {
  (event: 'on-bottom-scroll'): void
  (event: 'update'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Scroll',
  props: {
    hiddenTracks: { type: Boolean, default: false },
    updateOn: { default: 0 },
    yPosition: { default: 0 },
    onBeforeUnmount: { type: Function, default: () => {} }
  },
  emits: ["on-bottom-scroll", "update"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
const emits = __emit

const element = ref() as Ref<HTMLElement>
const instance = ref() as Ref<Scrollbar>
const options: Partial<ScrollbarOptions> = {
  alwaysShowTracks: true,
  damping: 0.04,
  plugins: {},
}

const handleScroll: ScrollListener = (status: ScrollStatus) => {
  const isOnBottom = status.limit.y === status.offset.y

  if (isOnBottom) {
    emits('on-bottom-scroll')
  }
}

onMounted(() => {
  instance.value = Scrollbar.init(element.value, options)
  instance.value.addListener(handleScroll)
  if (props.yPosition) {
    instance.value.setPosition(undefined, props.yPosition)
  }
})

onBeforeUnmountVue(() => props.onBeforeUnmount?.(instance.value))

onUpdated(() => {
  instance.value.update()
  emits('update')
})

onUnmounted(() => {
  Scrollbar.destroy(element.value)
  instance.value.removeListener(handleScroll)
})

__expose({ element, instance })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "element",
    ref: element,
    class: _normalizeClass(`scrollbar-wrapper ${props.hiddenTracks ? 'hidden-tracks' : ''}`)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2 /* CLASS */))
}
}

})